import * as angular from 'angular';
import { config } from 'angular/utils/config';

export interface StorageOfferResource extends ng.resource.IResourceClass<
    ng.resource.IResource<StorageOfferDto | StorageDocumentDto | undefined>
> {
    page: ng.resource.IResourceMethod<
        ng.resource.IResource<DataPageDto<StorageOfferDto>>
    >;
    upload: ng.resource.IResourceMethod<
        ng.resource.IResource<StorageDocumentDto>
    >;
    placeBid: ng.resource.IResourceMethod<ng.resource.IResource<undefined>>; // TODO Or maybe null?
    deleteBid: ng.resource.IResourceMethod<ng.resource.IResource<undefined>>; // TODO Or maybe null?
    updateBid: ng.resource.IResourceMethod<ng.resource.IResource<undefined>>;
    getBids: ng.resource.IResourceMethod<
        ng.resource.IResource<Array<StorageOfferBidDto>>
    >;
    getSellBids: ng.resource.IResourceMethod<
        ng.resource.IResource<Array<StorageOfferSellBidDto>>
    >;
    getSellBid: ng.resource.IResourceMethod<
        ng.resource.IResource<StorageOfferSellBidDto>
    >;
    deleteSellBid: ng.resource.IResourceMethod<ng.resource.IResource<null>>;
    placeSellBid: ng.resource.IResourceMethod<
        ng.resource.IResource<StorageOfferSellBidDto>
    >;
    updateSellBid: ng.resource.IResourceMethod<
        ng.resource.IResource<StorageOfferSellBidDto>
    >;
    sendOfferAllocationAcceptance: ng.resource.IResourceMethod<
        ng.resource.IResource<StorageAllocationAcceptanceDto>
    >;
    updateReservePrice: ng.resource.IResourceMethod<
        ng.resource.IResource<StorageBiddingPriceDto>
    >;
    getTradedQuantity: ng.resource.IResourceMethod<
        ng.resource.IResource<StorageTradedQuantityDto>
    >;
}

function storageOfferResource(
    $resource: ng.resource.IResourceService
): StorageOfferResource {
    return <StorageOfferResource>$resource(
        config.monolithApi + '/storage-offer/:id',
        { id: '@id' },
        {
            page: {
                method: 'GET',
                url: config.monolithApi + '/storage-offer/page',
                isArray: false
            },
            upload: {
                method: 'POST',
                url: config.monolithApi + '/storage-offer/upload-attachment',
                transformRequest: angular.identity,
                headers: { 'Content-Type': undefined }
            },
            placeBid: {
                method: 'POST',
                url: config.monolithApi + '/storage-offer/:id/bid'
            },
            updateBid: {
                method: 'PUT',
                url: config.monolithApi + '/storage-offer/:id/update-bid'
            },
            getBids: {
                method: 'GET',
                url: config.monolithApi + '/storage-offer/:id/bid',
                isArray: true
            },
            deleteBid: {
                method: 'DELETE',
                url: config.monolithApi + '/storage-offer/bids/:id'
            },
            placeSellBid: {
                method: 'POST',
                url: config.monolithApi + '/storage-offer/:id/sell-bids'
            },
            updateSellBid: {
                method: 'PUT',
                url:
                    config.monolithApi + '/storage-offer/:offerId/sell-bids/:id'
            },
            getSellBids: {
                method: 'GET',
                url: config.monolithApi + '/storage-offer/:id/sell-bids',
                isArray: true
            },
            getSellBid: {
                method: 'GET',
                url:
                    config.monolithApi + '/storage-offer/:offerId/sell-bids/:id'
            },
            deleteSellBid: {
                method: 'DELETE',
                url:
                    config.monolithApi + '/storage-offer/:offerId/sell-bids/:id'
            },
            sendOfferAllocationAcceptance: {
                method: 'POST',
                url:
                    config.monolithApi +
                    '/storage-offer/:id/allocation-acceptance'
            },
            updateReservePrice: {
                method: 'PUT',
                url:
                    config.monolithApi +
                    '/storage-offer/:offerId/product/:id/reserve-price'
            },
            getTradedQuantity: {
                method: 'GET',
                url:
                    config.monolithApi +
                    '/storage-offer/:offerId/traded-quantity'
            }
        }
    );
}

angular.module('app').factory('storageOfferResource', storageOfferResource);
